function NavDots(params) {
    if (!params.element || !params.container) {
        return;
    }
  
    this.setDefaults(params);
    this.addListeners();
};

NavDots.prototype.setDefaults = function (params) {
    this.element = $(params.element);
    this.container = $(params.container);
    this.direction = params.direction || true;
    this.speed = params.speed || 'slow';
};

NavDots.prototype.addListeners = function () {
    this.element.find('.nav-dot').on('click touchstart', this.onDotClick.bind(this));
};

NavDots.prototype.onDotClick = function (e) {
    e.preventDefault();
    e.stopPropagation();
    
    var width = this.container[0].scrollWidth * (this.direction ? 1 : -1);
    var offset = (this.container[0].scrollWidth - this.element[0].scrollWidth) * (this.direction ? 1 : 0);
    
    $('.nav-dot').toggleClass('active');
    this.container.animate({
        scrollLeft: width
    }, this.speed).find('.nav-dots').animate({
        left: offset
    }, 'slow');
    
    this.direction = !this.direction;
};

(function ($) {
    $('.nav-dots').each(function (index, element) {
        new NavDots({
            element: $(element),
            container: '.partner-landing-columns__wrapper',
            direction: true,
            speed: 'slow'
        });
    });
})(jQuery);